<script lang="ts">
  import AddModul from "./AddModul.svelte";
  import {
    collection,
    DocumentData,
    getDocs,
    orderBy,
    query,
    QueryDocumentSnapshot,
  } from "firebase/firestore";
  import { db } from "./firebase";
  import type { anniversary } from "./anniversary";
  import type { weddingDay } from "./common/weddingdaysnames";
  import { getDays } from "./common/weddingdaysnames";

  $: birthdayDates = [];
  let today = new Date();
  today.setHours(1, 0, 0, 0);

  let weddingdaysnames = getDays();

  $: objs = [];
  $: vox = [];

  getData();

  async function getData() {
    const queryValue = query(collection(db, "Feiertag"), orderBy("Date"));
    let docs = [];

    const snap = await getDocs(queryValue);
    snap.forEach((s) => {
      let entry = s.data();

      entry.Date = entry.Date.toDate();
      entry.Date.setHours(1, 0, 0, 0);
      entry.Date2 = new Date(entry.Date.getTime());
      entry.Date2.setFullYear(today.getFullYear());
      if (entry.Date2 < today) {
        entry.Date2.setFullYear(today.getFullYear() + 1);
      }
      docs.push(entry);
      console.log(entry);
    });

    objs = docs;
    getDateList();
  }

  function getDateList() {
    let list = [
      ...new Set(
        objs
          .filter((a) => a.Date2 >= today)
          .map((a) => a.Date2.getTime())
          .sort(function (a, b) {
            return a - b;
          })
      ),
    ];

    // let list = [
    //   ...new Set(
    //     objs
    //       .filter((a) => a.Type !== 2 && a.Date2 >= today)
    //       .map((a) => a.Date2.getTime())
    //       .sort(function (a, b) {
    //         return a - b;
    //       })
    //   ),
    // ];

    // let list2 = [
    //   ...new Set(
    //     objs
    //       .filter((a) => a.Type === 2 && a.Date2 >= today)
    //       .map((a) => a.Date2.getTime())
    //       .sort(function (a, b) {
    //         return a - b;
    //       })
    //   ),
    // ];

    let list3 = [];
    // TODO ungerade Daten hinzufügen
    // list2.forEach((h: anniversary) =>
    //   h.Date.setFullYear(h.Date.getFullYear() + 12)
    // );

    birthdayDates = list.map((d) => new Date(d));
    // let bla = list2.map((d) => new Date(d));
    // birthdayDates = [...birthdayDates, bla];
    // birthdayDates = birthdayDates.flat();
  }
</script>

<svelte:head>
  <title>Jahrestage</title>
  <html lang="de" />
</svelte:head>

<main>
  <h1>Jahrestage</h1>

  <AddModul />

  <button on:click={getData}>Test</button>

  {#each birthdayDates as d}
    <h3>{d.toLocaleDateString("de")}</h3>
    {#each objs as day}
      {#if day.Date2.toDateString() == d.toDateString()}
        <ul>
          <p>
            {#if day.Type === 1}
              Geburtstag
              <b>{day.Name}</b>
              ({d.getFullYear() - day.Date.getFullYear()})
            {/if}

            {#if day.Type === 2}
              Hochzeitstag
              <b>{day.Name}</b>
              ({d.getFullYear() - day.Date.getFullYear()})
              {weddingdaysnames.find(
                (x) => x.year === d.getFullYear() - day.Date.getFullYear()
              ).name}
            {/if}

            {#if day.Type === 3}
              Verlobungstag
              <b>{day.Name}</b>
              ({d.getFullYear() - day.Date.getFullYear()})
            {/if}
          </p>
        </ul>
      {/if}
    {/each}
  {/each}
</main>

<style>
  main {
    text-align: center;
    padding: 1em;
    max-width: 240px;
    margin: 0 auto;
  }

  h1 {
    color: #ff3e00;
    text-transform: uppercase;
    font-size: 4em;
    font-weight: 100;
  }

  h3 {
    background-color: lightgray;
  }

  @media (min-width: 640px) {
    main {
      max-width: none;
    }
  }
</style>
